import { icon } from 'leaflet';

function createIcon(props) {
    return icon(props);
}

export { createIcon };